import React from "react";

//components
import Spinner from "../components/Spinner";

let types = {
  "success": "form__btn--success",
  "danger": "form__btn--danger",
  "warning": "form__btn--warning",
  "info": "form__btn--info"
};

let blocks = {
  "inline-block": "form__btn--inline-block",
  "inline": "form__btn--inline",
  "block": "form__btn--block",
  "flex": "form__btn--flex"
};

export default function NewButton(props) {
  let type = types[props.variant];
  let block = blocks[props.block];

  let classes = `form__btn ${type} ${block}`;

  let isLoading = props.loading ? <Spinner /> : props.children;

  return (
    <button type={props.type} className={classes} onClick={props.onClick}>
      {isLoading}
    </button>
  );
}